import * as yup from "yup";

export const yupMatchTime = yup.string().matches(/^(\d{2}):(\d{2}):(\d{2})$/, {
  message: "Tempo inválido",
  excludeEmptyString: true,
});
